import { faqItems } from '@/mocks/homeData';
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
            ❓ 常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            关于<span className="text-primary-500">吃瓜网</span>
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-secondary-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-secondary-50/50 transition-colors"
              >
                <span className="text-foreground-900 text-sm font-semibold font-heading pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-add-line text-foreground-400 text-lg flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}